
module.exports = function (settingsService, atmService) {
    return {
        restrict: 'E',
        scope: {
            isProductTile: '=?'
        },
        controllerAs: 'vm',
        link(scope) {
            const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            const isAndroid = /Android/i.test(navigator.userAgent);
            const isDesktop = (!isIos && !isAndroid);

            // we have 3 variants for display text and legal text, depends on mobile web or product detail page
            scope.vm = {
                downloadAppUrl: '',
                displayText: 'Download app',
                legalText: 'Appy Deal not available on our website',
                showDownloadIcon: true,
                isProductTile: scope.isProductTile,
                isMobile: !isDesktop
            };

            if (!scope.vm.isProductTile || isDesktop) {
                scope.vm.displayText = 'Download app for Appy Deals';
                scope.vm.legalText = 'Not available on our website';
            }

            if (isDesktop) {
                scope.vm.showDownloadIcon = false;
            }

            scope.vm.handleDownloadApp = () => {
                const pageType = scope.vm.isProductTile
                    ? 'plp'
                    : 'pdp';

                atmService.push({
                    event: 'BWSlinkClick',
                    eventContext: {
                        linkType: 'appy deals download app',
                        linkName: `web:${pageType}:appy deals:download app`
                     }
                });
            };

            settingsService
                .getSettingValue('Loyalty', 'AppDownloadLinkForABP')
                .then((val) => {
                    scope.vm.downloadAppUrl = `${val || ''}`;
                });
        },
        template: require('./download-app-button-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/download-app-button/download-app-button-directive.js
 **/